import React from 'react';
import { Link } from 'react-router-dom';

import './styles/TelegramBotsPromo.scss';

const promoSteps = [
    {
        number: '01',
        title: 'Обращение',
        text: 'Бот встречает клиента в Telegram',
    },
    {
        number: '02',
        title: 'Квалификация',
        text: 'Уточняет задачу и собирает контакты',
    },
    {
        number: '03',
        title: 'Действие',
        text: 'Ведёт к записи, заказу или оплате',
    },
    {
        number: '04',
        title: 'CRM',
        text: 'Передаёт менеджеру диалог и данные',
    },
];

export default function TelegramBotsPromo() {
    return (
        <section
            className="telegram-bots-promo"
            aria-labelledby="telegram-bots-promo-title"
        >
            <div className="telegram-bots-promo__inner">
                <div className="telegram-bots-promo__content">
                    <p className="telegram-bots-promo__eyebrow">Новая услуга Landlix</p>
                    <h2 id="telegram-bots-promo-title">
                        Telegram-боты, которые берут рутину на себя
                    </h2>
                    <p className="telegram-bots-promo__lead">
                        Собираем заявки, консультируем, записываем, принимаем заказы
                        и передаём всё нужное в ваши бизнес-системы. При необходимости
                        подключаем ИИ по вашей базе знаний.
                    </p>

                    <ul className="telegram-bots-promo__benefits">
                        <li>Приём обращений 24/7</li>
                        <li>ИИ по вашей базе знаний</li>
                        <li>CRM, таблицы, календарь и API</li>
                    </ul>

                    <div className="telegram-bots-promo__actions">
                        <Link
                            className="telegram-bots-promo__button telegram-bots-promo__button--primary"
                            to="/telegram-bots"
                        >
                            Посмотреть возможности
                        </Link>
                        <a
                            className="telegram-bots-promo__button telegram-bots-promo__button--secondary"
                            href="https://t.me/landlix_support_bot"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Обсудить задачу
                        </a>
                    </div>
                </div>

                <div
                    className="telegram-bots-promo__visual"
                    aria-label="Сценарий работы Telegram-бота: от обращения до передачи данных в CRM"
                >
                    <div className="telegram-bots-promo__hub" aria-hidden="true">
                        <span>Telegram</span>
                        <strong>Бот для бизнеса</strong>
                        <small>Сценарии · ИИ · Интеграции</small>
                    </div>
                    <ol className="telegram-bots-promo__flow">
                        {promoSteps.map((step) => (
                            <li key={step.number}>
                                <span className="telegram-bots-promo__step-number">
                                    {step.number}
                                </span>
                                <span>
                                    <strong>{step.title}</strong>
                                    <small>{step.text}</small>
                                </span>
                            </li>
                        ))}
                    </ol>
                </div>
            </div>
        </section>
    );
}
